import StyleMentors from "./Mentors.module.css";
import React, {useState} from "react";
import {ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ReactGA from "react-ga4";

function MentorsCard(props) {
    const [mentorModalOpen, setMentorModalOpen] = useState(false)

    function sendEvent(id) {
        ReactGA.event( {
            action: "mentor instagram click",
            category:"external navigate",
            label: "Start page: mentor section",
            value: id
        })
    }

    return (
        <>
            <div className={StyleMentors.card}>
                <img className={StyleMentors.image} src={props.photoLink} alt={""}></img>
                <h5 className={StyleMentors.title}>{props.name}</h5>
                <div className={StyleMentors.text}>{props.shortBio}</div>
                <div className={StyleMentors.button}>
                    <a onClick={() => setMentorModalOpen(!mentorModalOpen)} target="_blank"><b>Детальніше</b></a>
                </div>
            </div>
            {mentorModalOpen &&
                <Modal
                    style={{marginTop: "40px"}}
                    show={true}
                    onHide={() => setMentorModalOpen(false)}
                >
                    <ModalHeader>
                        <ModalTitle>{props.name}</ModalTitle>
                    </ModalHeader>

                    <ModalBody>
                        <div>
                            <div style={{float: "left", marginRight: "12px"}}>
                                <img className={StyleMentors.image} src={props.photoLink} alt={""}></img>
                            </div>
                            <div dangerouslySetInnerHTML={{__html: props.longBio === "" ? props.shortBio : props.longBio}}></div>
                        </div>
                    </ModalBody>
                    <ModalFooter style={{justifyContent: "center"}}>
                        <div className={StyleMentors.buttonContact}>
                            <a onClick={() => sendEvent(props.id)} href={props.instagram} target="_blank"><b>Моя сторінка</b></a>
                        </div>
                    </ModalFooter>
                </Modal>}
        </>
    )
}

export default MentorsCard;
